export default __webpack_public_path__ + "static/media/blog-34-image-3.88240f0c.jpg";